import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgForm } from '@angular/forms';
import { EnvService } from '../../env.service';

import {
  MatSnackBar,
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
} from '@angular/material/snack-bar';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-verify-account',
  templateUrl: './verify-account.component.html',
  styleUrls: ['./verify-account.component.css']
})
export class VerifyAccountComponent implements OnInit {

  horizontalPosition: MatSnackBarHorizontalPosition = 'center';
  verticalPosition: MatSnackBarVerticalPosition = 'top';

  isLoading = true;
  verificationSession = false;
  passwordSession = false;
  uniqueId = ""

  constructor(private http: HttpClient, private router: Router, private env: EnvService, private route: ActivatedRoute, private _snackBar: MatSnackBar) { }

  ngOnInit(): void {
    this.route.url.subscribe(url => {
      console.log(url[0].path, url[1].path)
      if(url[0].path === 'verifyAccount') {
        this.verificationSession = true;
      } else {
        this.passwordSession = true;
      }
      this.uniqueId = url[1].path;
      this.isLoading = false;
      return;
    });

  }

  openSnackBar(msg) {
    this._snackBar.open(msg, '', {
      duration: 2000,
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
    });
  }

  onUpdatePassword(form: NgForm) {
    console.log(form.value);
    if (form.invalid) return;

    if(form.value.password1 != form.value.password2) {
      this.openSnackBar("Both the entered passwords should be same");
      return;
    }

    this.http.post(this.env.apiUrl + "/api/user/changePassword", {password1: form.value.password1, password2: form.value.password2, id: this.uniqueId})
    .subscribe(response => {
      console.log(response);
      this.openSnackBar("Password updated successfully redirecting to login page");
      setTimeout(() => {
        this.router.navigate(['login']);
      }, 2000);
    }, err => {
      console.log(err);
    })

  }

  onVerifyAccount() {
    this.http.post(this.env.apiUrl + "/api/user/verifyAccount", {id: this.uniqueId})
    .subscribe(response => {
      console.log(response);
      this.openSnackBar("Account verified successfully redirecting to login page");
      setTimeout(() => {
        this.router.navigate(['login']);
      }, 2000);
    }, err => {
      console.log(err);
    })
  }

}
